import firebase from "firebase/app";
import "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyDkYzCvdjPnTlnv0RVZBaVVKkm-osrxEfc",
  authDomain: "bonjourfrenchclassroom-b0abe.firebaseapp.com",
  databaseURL: "https://bonjourfrenchclassroom-b0abe.firebaseio.com",
  projectId: "bonjourfrenchclassroom-b0abe",
  storageBucket: "",
  messagingSenderId: "204005411324",
  appId: "1:204005411324:web:3090221e64c8afe9"
};

const firebaseApp = firebase.initializeApp(config);
export { firebaseApp as default, firebase };
